import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import IntersectionObserver from '@researchgate/react-intersection-observer';
import { isBrowser } from '@xingternal/check-platform';

// _lazy_ load intersection observer polyfill
// but only if we are on browser, because
// the polyfill wants to populate the window object
if (isBrowser) {
  require('intersection-observer');
}

const IntersectionObserverMock = ({ children }) => (
  <Fragment>{children}</Fragment>
); // eslint-disable-line

IntersectionObserverMock.propTypes = {
  children: PropTypes.node.isRequired,
};

export default isBrowser ? IntersectionObserver : IntersectionObserverMock;
